import { Controller } from "stimulus"
import firebase from "firebase/app"
import "firebase/analytics"
import "firebase/auth"

export default class extends Controller {
  static targets = [
    "form",
    "name",
    "email",
    "password",
    "failedMessage",
    "submitBtn",
    "firebaseToken"
  ]

  initialize() {
    const firebaseConfig = {
      apiKey: "AIzaSyCjnHGniSA69myNmeSrb5YZs66Edsr864k",
      authDomain: "soundwrks.firebaseapp.com",
      databaseURL: "https://soundwrks.firebaseio.com",
      projectId: "soundwrks",
      storageBucket: "soundwrks.appspot.com",
      messagingSenderId: "745789251438",
      appId: "1:745789251438:web:cfde63a85dd4b98803ab7f",
      measurementId: "G-BZ63JZKNST",
    }

    if (firebase.apps.length === 0) {
      firebase.initializeApp(firebaseConfig)
    }

    this._handleRedirectBack()
  }

  // see https://firebase.google.com/docs/auth/web/password-auth#sign_in_a_user_with_an_email_address_and_password
  login(e) {
    e.preventDefault()
    this._resetFields()

    firebase
      .auth()
      .signInWithEmailAndPassword(this.emailTarget.value, this.passwordTarget.value)
      .then((userCredential) => {
        userCredential.user.getIdToken().then((token) => {
          this.firebaseTokenTarget.value = token
          this.formTarget.submit()
        })
      })
      .catch((error) => {
        this.passwordTarget.classList.add("is-invalid")

        const errCode = error.code

        if (errCode == "auth/user-not-found" || errCode == "auth/wrong-password") {
          this.failedMessageTarget.textContent = "Invalid email and password combination"
        } else {
          this.failedMessageTarget.textContent = error.message
        }
        this.failedMessageTarget.classList.remove("d-none")
      })
      .finally((_) => {
        this.submitBtnTarget.disabled = false
      })
  }

  // see https://firebase.google.com/docs/auth/web/password-auth#create_a_password-based_account
  signup(e) {
    e.preventDefault()
    this._resetFields()
    
    firebase
      .auth()
      .createUserWithEmailAndPassword(this.emailTarget.value, this.passwordTarget.value)
      .then((userCredential) => {
        userCredential.user.getIdToken().then((token) => {
          this.firebaseTokenTarget.value = token
          this.formTarget.submit()
        })
      })
      .catch((error) => {
        this.failedMessageTarget.textContent = error.message
        this.failedMessageTarget.classList.remove("d-none")
      })
      .finally((_) => {
        this.submitBtnTarget.disabled = false
      })
  }

  // see https://firebase.google.com/docs/auth/web/google-signin
  signInWithGoogle(e) {
    e.preventDefault()
    var provider = new firebase.auth.GoogleAuthProvider()
    // This will actually create a new user if not existing yet.
    firebase.auth().signInWithRedirect(provider)
  }

  // see https://firebase.google.com/docs/auth/web/apple
  signInWithApple(e) {
    e.preventDefault()
    var provider = new firebase.auth.OAuthProvider('apple.com')
    // This will actually create a new user if not existing yet.
    firebase.auth().signInWithRedirect(provider)
  }

  // see https://firebase.google.com/docs/auth/web/facebook-login
  signInWithFacebook(e) {
    e.preventDefault()
    var provider = new firebase.auth.FacebookAuthProvider()
    // This will actually create a new user if not existing yet.
    firebase.auth().signInWithRedirect(provider)
  }

  _resetFields() {
    this.submitBtnTarget.disabled = true
    this.failedMessageTarget.classList.add("d-none")
    this.passwordTarget.classList.remove("is-invalid")
  }

  _handleRedirectBack() {
    this.submitBtnTarget.disabled = true

    firebase
      .auth()
      .getRedirectResult()
      .then((result) => {
        this.submitBtnTarget.disabled = false
        
        if (result && result.user) {
          this.submitBtnTarget.disabled = true

          result.user.getIdToken().then((token) => {
            this.firebaseTokenTarget.value = token
            this.formTarget.submit()
          })
        }
      })
      .catch((error) => {
        this.submitBtnTarget.disabled = false
        this.failedMessageTarget.textContent = error.message
        this.failedMessageTarget.classList.remove("d-none")
      })
  }
}
